@if (unreadNotificationCount) {
  <div class="unread-badge" [class.with-text]="!hideText" [class.without-text]="hideText">
    {{ hideText ? '' : unreadNotificationCount }}
  </div>
}
